import { inject, NgModule } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { CombinedGraphQLErrors, ServerError } from '@apollo/client/errors';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';
import { ErrorLink } from '@apollo/client/link/error';
import { MatSnackBar } from '@angular/material/snack-bar';

export function createApollo(snackBar: MatSnackBar): ApolloClient.Options {
  const uri = '/api/graphql';

  const uploadLink = new UploadHttpLink({
    uri,
    headers: {
      'X-Apollo-Operation-Name': 'uploadFile',
    },
  });

  const errorLink = new ErrorLink(({ error }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) =>
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        ),
      );
      return;
    }

    if (ServerError.is(error)) {
      console.log(`[Network error]: ${error}`);
      if (error.statusCode === 504) {
        snackBar.open(`[${error.name}] The backend was not available (504)`);
      } else if (error.statusCode > 500) {
        snackBar.open(`[${error.name}] A network error occurred`);
      } else {
        snackBar.open(`[${error.name}] An error occurred: ${error.statusCode}`);
      }
      return;
    }

    if (error) {
      console.log(`[Network error]: ${error}`);
      snackBar.open(`[${error.name}] A network error occurred`);
    }
  });

  return {
    link: errorLink.concat(uploadLink),
    cache: new InMemoryCache(),
  };
}

@NgModule({
  providers: [
    provideApollo(() => createApollo(inject(MatSnackBar))),
  ],
})
export class GraphQLModule {}
